/// <reference path="../../common/modals/modals.ts" />

namespace OfficeGuy.Apps {
    export class CustomerService {
        static CounterInterval;

        static InitShortcuts(TicketID) {
            $(document)
                .off("keyup.r")
                .on("keyup.r", null, "r", function () {
                    if ($(".og-customerservice-message").length == 0) {
                        $(document).off("keyup.r");
                        return true;
                    }
                    if ($(".modal form").length != 0)
                        return true;
                    OfficeGuy.Modals.ShowURLModal("/customerservice/compose/?id=" + TicketID);
                    return false;
                });
            $(document)
                .off("keyup.e")
                .on("keyup.e", null, "e", function () {
                    if ($(".og-customerservice-message").length == 0) {
                        $(document).off("keyup.e");
                        return true;
                    }
                    if ($(".modal form").length != 0)
                        return true;
                    $(".og-customerservice-ticket-close").trigger("click");
                    return false;
                });
        }

        static InitCounter(SecondsAgo) {
            var StartTime = new Date();
            StartTime.setSeconds(StartTime.getSeconds() - SecondsAgo);
            if (CustomerService.CounterInterval != null)
                clearInterval(CustomerService.CounterInterval);
            var RefreshCounter = function () {
                $("#DurationMinutes").attr("placeholder", Math.max(Math.ceil((new Date().getTime() - StartTime.getTime()) / 1000 / 60), 1)).trigger("change");
            };
            CustomerService.CounterInterval = setInterval(RefreshCounter, 10000);
            RefreshCounter();
        }

        static StoreCounter() {
            var $DurationMinutes = $("#DurationMinutes");
            if ($DurationMinutes.val() == "")
                $DurationMinutes.val($DurationMinutes.attr("placeholder"));
        }
    }
}
